import React, { useEffect, useMemo, useState } from 'react';
import { getProxyUrl } from '@shared/utils/proxy-url';

type RetryImgProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  maxRetries?: number;
  retryDelayMs?: number;
};

export const RetryImg: React.FC<RetryImgProps> = ({
  src,
  maxRetries = 3,
  retryDelayMs = 1000,
  onError,
  ...rest
}) => {
  const [attempt, setAttempt] = useState<number>(0);
  const [currentSrc, setCurrentSrc] = useState<string | undefined>(src as string | undefined);

  useEffect(() => {
    setAttempt(0);
    setCurrentSrc(src as string | undefined);
  }, [src]);

  const bustedSrc = useMemo(() => {
    if (!currentSrc) return currentSrc;
    
    // Преобразуем URL через прокси в режиме разработки
    const proxySrc = getProxyUrl(currentSrc);
    
    try {
      const url = new URL(proxySrc, window.location.origin);
      if (attempt > 0) {
        url.searchParams.set('r', String(Date.now()));
      }
      
      // Убираем добавление cors параметра, так как он может вызывать проблемы
      // if (!import.meta.env.DEV && (currentSrc.includes('cloudfront.net') || currentSrc.includes('amazonaws.com'))) {
      //   url.searchParams.set('cors', 'true');
      // }
      
      return url.toString();
    } catch {
      return proxySrc; // если это невалидный URL, отдаем как есть
    }
  }, [currentSrc, attempt]);

  // Определяем, нужно ли устанавливать crossOrigin
  const crossOrigin = useMemo(() => {
    // В режиме разработки через прокси crossOrigin не нужен
    if (import.meta.env.DEV) {
      return undefined;
    }
    
    if (currentSrc && (currentSrc.includes('cloudfront.net') || currentSrc.includes('amazonaws.com'))) {
      return 'anonymous';
    }
    return undefined;
  }, [currentSrc]);

  return (
    <img
      {...rest}
      src={bustedSrc}
      crossOrigin={crossOrigin}
      onError={(e) => {
        if (attempt < maxRetries) {
          setTimeout(() => setAttempt((a) => a + 1), retryDelayMs);
        }
        onError?.(e as any);
      }}
    />
  );
};

export default RetryImg;





